import React from "react";
import { Rate as Rating } from "antd";
import colors from "../../share/constants/constants";

const Rate = ({ value, disabled, defaultValue }) => {
  return (
    <>
      <Rating
        style={{
          color: colors.secondaryOrange,
        }}
        allowHalf={true}
        value={value}
        disabled={disabled}
        defaultValue={defaultValue}
      />
    </>
  );
};

export default Rate;
